import { useState } from "react";
import Modal from "@/components/Modal";

export function Confirm({ open, onClose, title, message, count, requireText, danger = true, confirmLabel = "Confirmer", onConfirm, testid = "admin-confirm" }) {
  const [txt, setTxt] = useState("");
  const ok = !requireText || txt.trim() === String(requireText).trim();
  const close = () => { setTxt(""); onClose(); };
  return (
    <Modal open={open} onClose={close} title={title} testid={testid}>
      <div className="space-y-4">
        {count !== undefined && <p className="rounded-md bg-[#B03A3A]/10 p-3 text-sm font-bold text-[#B03A3A]" data-testid={`${testid}-count`}>{count} élément(s) concerné(s)</p>}
        {message && <p className="text-sm text-[#16163F]">{message}</p>}
        {requireText && <label className="block"><span className="lbl">Pour confirmer, saisissez exactement : <span className="mono font-bold">{requireText}</span></span>
          <input className="inp" value={txt} onChange={(e) => setTxt(e.target.value)} data-testid={`${testid}-input`} /></label>}
        <div className="flex justify-end gap-2">
          <button type="button" className="btn-ghost" onClick={close} data-testid={`${testid}-cancel`}>Annuler</button>
          <button className={danger ? "btn-danger" : "btn-primary"} disabled={!ok} onClick={async () => { await onConfirm(txt); setTxt(""); }} data-testid={`${testid}-ok`}>{confirmLabel}</button>
        </div>
      </div>
    </Modal>
  );
}

export const Check = ({ checked, onChange, testid, disabled }) => (
  <input type="checkbox" className="h-4 w-4 accent-[#A5894E]" checked={!!checked} disabled={disabled} onClick={(e) => e.stopPropagation()} onChange={(e) => onChange(e.target.checked)} data-testid={testid} />
);

export const toggle = (list, v, on) => (on ? [...new Set([...(list || []), v])] : (list || []).filter((x) => x !== v));
